/**
 * Maps for exposing translated JS to html templates.
 *
 * TODO(sgutz) Separate out by project
 */
goog.provide('yext.ecl.i18n');
goog.provide('yext.linkedaccts.i18n');
goog.provide('yext.listings.i18n');
goog.provide('yext.locations.i18n');
goog.provide('yext.notifications.i18n');
goog.provide('yext.sites.i18n');
goog.provide('yext.stormdashboard.i18n');
goog.provide('yext.subscriptions.i18n');
goog.provide('yext.templates.i18n');


yext.ecl.i18n.msg = {
  'Menu': {
    listsNoLocationsMessage: function(n, locationSearchUrl) {
      return yext.msgn(
        'This menu is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Location</a> tab to associate it with locations.',
        'This menu is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Locations</a> tab to associate it with locations.',
        n, locationSearchUrl);
    },
    listsNoItemMessage: yext.msg(
      'This menu is empty. Add menu items for it to appear on your listings.'),
  },
  'ProductList': {
    listsNoLocationsMessage: function(n, locationSearchUrl) {
      return yext.msgn(
        'This list is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Location</a> tab to associate it with locations.',
        'This list is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Locations</a> tab to associate it with locations.',
        n, locationSearchUrl);
    },
    listsNoItemMessage: yext.msg(
      'This list is empty. Add products or services for it to appear on your listings.'),
  },
  'Calendar': {
    listsNoLocationsMessage: function(n, locationSearchUrl) {
      return yext.msgn(
        'This calendar is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Location</a> tab to associate it with locations.',
        'This calendar is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Locations</a> tab to associate it with locations.',
        n, locationSearchUrl);
    },
    listsNoItemMessage: yext.msg(
      'This calendar is empty. Add events for it to appear on your listings.'),
  },
  'Bios': {
    listsNoLocationsMessage: function(n, locationSearchUrl) {
      return yext.msgn(
        'This list is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Location</a> tab to associate it with locations.',
        'This list is visible but is not associated with any locations. ' +
          'Visit the <a href="{1}">Locations</a> tab to associate it with locations.',
        n, locationSearchUrl);
    },
    listsNoItemMessage: yext.msg(
      'This list is empty. Add products or services for it to appear on your listings.'),
  },
};

yext.templates.i18n.msg = {
  deleteTemplate: yext.msg('Delete Template'),
};

yext.locations.i18n.msg = {
  addOption: yext.msg('Add another option'),
  deleteExport: yext.msg('Delete Export'),
  deleteTemplate: yext.msg('Delete Template'),
  generateExport: yext.msgc('location-export', 'Generating export...'),
  // TRANSLATORS: Message indicating there was an error generating the export file for download
  cantDownloadExport: yext.msgc('location-export', 'Unable to download export.'),
};

yext.notifications.i18n.msg = {
  deleteNotificationConfirm: yext.msg('Are you sure you want to delete this analytics notification?'),
  deleteNotification: yext.msg('Deleting Analytics Notification'),
  deleteReview: yext.msg('Deleting Review Notification'),
  deleteReviewConfirm: yext.msg('Are you sure you want to delete this review notification?'),
  deleteIssueNotificationConfirm: yext.msg('Are you sure you want to delete this location issues notification?'),
  deleteIssueNotification: yext.msg('Deleting Location Issues Notification'),
};

yext.subscriptions.i18n.msg = {
  processing: yext.msg('Processing'),
  // TRANSLATORS: Add a new name, email, and phone for billing purposes
  addContact: yext.msg('Add a New Contact'),
};

yext.sites.i18n.msg = {
  statusAnnouncement: yext.msgc('listings', 'Status Announcement'),
};

yext.listings.i18n.msg = {
  noGooglePlus: function(brand) {
    // TRANSLATORS: The parameter is a brand name
    return yext.msgc('listings', 'We were unable to find your Google+ Local listing. ' +
        'Once you have claimed your listing with Google directly, you can opt out and' +
       ' opt back in to connect the listing to {0}',
    brand);
  },
  listingNotFound: function(brand) {
    // TRANSLATORS: The parameter is a brand name
    return yext.msgc('listings', 'We were unable to find a listing that matches your' +
        ' location on {0}',
    brand);
  },
};

yext.linkedaccts.i18n.msg = {
  tryAgain: yext.msg('There was an error processing your request. Please try again.'),
  assignAcctToLocation: function(brand) {
    return yext.msg('Are you sure you want to assign this {0} account to this location?', brand);
  },
  assignAcctToAllLocations: function(brand) {
    return yext.msg('Are you sure you want to assign this {0} account to all locations?', brand);
  },
  assignAcctToFolder: function(brand) {
    return yext.msg('Are you sure you want to assign this {0} account to this folder?', brand);
  },
  unlinkBrandConfirm: function(brand) {
    // TRANSLATORS: {0} is the name of the brand (like Facebook)
    return yext.msg('Are you sure you want to unlink your {0} account?', brand);
  },
  errorDialog1: yext.msg('Our partner site is currently unavailable. Please try again at a later time'),
  errorDialog2: yext.msg('Partner Site Unavailable'),
  errorProcessing: yext.msg('There was an error processing your request. Please try again.'),
  assignconfirm: yext.msg('Are you sure you want to assign this account?'),
  unlinkConfirm: yext.msg('Are you sure you want to unlink your account?'),
};

yext.stormdashboard.i18n.msg = {
  internalerror: yext.msg('An internal error occurred. Please try again later.'),
  loading: yext.msg('Loading ...'),
  addcc: yext.msg('Add Credit Card'),
  editcc: yext.msg('Edit Credit Card'),
  saving: yext.msg('Saving ...'),
  deletecc: yext.msg('Delete Credit Card'),
};

goog.exportSymbol('yext.ecl.i18n.msg', yext.ecl.i18n.msg);
goog.exportSymbol('yext.linkedaccts.i18n.msg', yext.linkedaccts.i18n.msg);
goog.exportSymbol('yext.listings.i18n.msg', yext.listings.i18n.msg);
goog.exportSymbol('yext.locations.i18n.msg', yext.locations.i18n.msg);
goog.exportSymbol('yext.notifications.i18n.msg', yext.notifications.i18n.msg);
goog.exportSymbol('yext.sites.i18n.msg', yext.sites.i18n.msg);
goog.exportSymbol('yext.stormdashboard.i18n.msg', yext.stormdashboard.i18n.msg);
goog.exportSymbol('yext.subscriptions.i18n.msg', yext.subscriptions.i18n.msg);
goog.exportSymbol('yext.templates.i18n.msg', yext.templates.i18n.msg);
